import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {usePages} from '../../hooks';
import {clearNotifications, notifyValidationErrors} from '../../components/ToastNotifications';
import NeuroMessage from '../../components/NeuroMessage';

const PageNavigation = ({className, hideNext, hidePrevious, innerNextBtn, innerPrevBtn, onNextPageClicked, onPreviousPageClicked, disableNextBtn, disablePreviousBtn, onDisabledClick, toastTimeout = 10000}) => {
  const { goToPreviousPage, goToNextPage, isLoadingNextPage, isAnimatingPages, validationErrors } = usePages();
  const nextBtnIsDisabled = disableNextBtn !== undefined ? disableNextBtn : validationErrors.length > 0;
  const prevBtnIsDisabled = disablePreviousBtn !== undefined ? disablePreviousBtn : false;
  const pageIsTransitioning = isLoadingNextPage || isAnimatingPages;

  const onDisabledClickFn = action => {
    onDisabledClick && onDisabledClick(action);
    if(!action.isReverse){
      notifyValidationErrors({ validationErrors, autoClose: toastTimeout });
    }
  };

  const cssBEM = 'page-navigation';
  const classes = classnames( cssBEM, {
    [`${cssBEM}--loading`]: isLoadingNextPage
  }, className);
  const classesPrevBtn = classnames(`${cssBEM}__prev`, 'btn', {
    disabled: prevBtnIsDisabled || pageIsTransitioning
  });
  const classesNextBtn = classnames(`${cssBEM}__next`, 'btn', {
    disabled: nextBtnIsDisabled || pageIsTransitioning
  });

  const validateBackwardClick = () => {
    if(prevBtnIsDisabled) {
      onDisabledClickFn({ isReverse: true });
    } else {
      clearNotifications();
      onPreviousPageClicked && onPreviousPageClicked();
      goToPreviousPage();
    }
  };

  const validateForwardClick = () => {
    if(nextBtnIsDisabled) {
      onDisabledClickFn({ isReverse: false });
    } else {
      clearNotifications();
      onNextPageClicked && onNextPageClicked();
      goToNextPage();
    }
  };

  const next = <button className={classesNextBtn} onClick={validateForwardClick} disabled={ pageIsTransitioning } aria-label="Next Page">
    { innerNextBtn ? (innerNextBtn) : <NeuroMessage id='nav.next' /> }
  </button>;

  const previous = <button className={classesPrevBtn} onClick={validateBackwardClick} disabled={ pageIsTransitioning } aria-label="Previous Page">
    { innerPrevBtn ? (innerPrevBtn) : <NeuroMessage id='nav.prev' /> }
  </button>;

  return <div className={classes} role="navigation" aria-label="Page Navigation">
    {!hidePrevious && previous}
    {!hideNext && next}
  </div>;
};

PageNavigation.propTypes = {
  className: PropTypes.string,
  disableNextBtn: PropTypes.bool,
  disablePreviousBtn: PropTypes.bool,
  hideNext: PropTypes.bool,
  hidePrevious: PropTypes.bool,
  innerNextBtn: PropTypes.node,
  innerPrevBtn: PropTypes.node,
  onDisabledClick: PropTypes.func,
  onNextPageClicked: PropTypes.func,
  onPreviousPageClicked: PropTypes.func,
  toastTimeout: PropTypes.number
};

export default PageNavigation;
